import React from "react";
import ReactDOM from "react-dom/client";
import Manifesto from "./manifesto";
import "../index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Manifesto />
  </React.StrictMode>,
);
